import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BROWSER_COOKIES, HEADERS } from '@finder/shared/constants/app.constants';
import { Observable } from 'rxjs';

@Injectable()
export class SsrTokensInterceptor implements HttpInterceptor {
    private browserCookies = inject(BROWSER_COOKIES, { optional: true });
    private requestHeaders = inject(HEADERS, { optional: true });

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Only SSR will have this token
        if (!this.browserCookies) {
            return next.handle(req);
        }

        // make sure the headers are sent along
        const headers = Object.keys(this.requestHeaders)
            .filter(key => key.includes('x-disney-internal-'))
            .reduce((dest, key) => {
                dest[key] = this.requestHeaders[key];

                return dest;
            }, {
                'X-Disney-Browser-Cookies': JSON.stringify(this.browserCookies, null, 0)
            });
        req = req.clone({
            setHeaders: headers,
            withCredentials: true
        });

        return next.handle(req);
    }
}
